import React from 'react';
import { RankStatusHero } from './RankStatusHero';
import { Roadmap } from './Roadmap';
import { OfficerData } from '../data/officers';
interface CareerViewProps {
  officer: OfficerData;
}
export function CareerView({
  officer
}: CareerViewProps) {
  return <div className="space-y-6" data-id="element-258" data-mp="a9l5fk89cify">
      <RankStatusHero officer={officer} data-id="element-259" data-mp="ecr9cl7wdxj9" />
      <Roadmap data-id="element-260" data-mp="ebpwcb7bn0yw" />
    </div>;
}